import React from "react";
import { View, StyleSheet, Text, FlatList, Platform } from "react-native";

import Dialog from "../../common/dialog";
import ReportUser from "./ReportUser";
import AppTheme from "../../AppTheme";
import TeamIconGradient from "../../common/icons/TeamIconGradient";

export default function RecipientsDialog({ recipients, close = () => {} }) {
  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        paddingTop: 0,
        marginTop: 0,
        paddingBottom: 8,
        paddingHorizontal: 8,
      }}
    >
      <View style={[styles.header]}>
        <TeamIconGradient style={styles.icon} width={20} height={20} />

        <View style={[styles.headerInfo]}>
          <Text style={styles.title}>Recipients</Text>
          <Text style={styles.subTitle}>This report is for: </Text>
        </View>
      </View>

      <View>
        <FlatList
          style={styles.scrollView}
          contentContainerStyle={{ paddingBottom: 40 }}
          data={recipients}
          keyExtractor={(user, index) => user.email || index.toString()}
          renderItem={({ item }) => <ReportUser user={item} />}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  scrollView: {
    marginTop: 5,
  },
  header: {
    height: 40,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginTop: 10,
  },
  subTitle: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: 6,
  },
});
